import { Dialog } from '@headlessui/react';
import { useCookieConsent } from '../providers/CookieConsentProvider';
import { Settings } from 'lucide-react';
import { useState } from 'react';

export const CookieConsent = () => {
  const {
    preferences,
    showBanner,
    savePreferences,
    acceptAll,
    rejectNonEssential,
  } = useCookieConsent();

  const [showPreferences, setShowPreferences] = useState(false);

  if (!showBanner) return null;

  if (!showPreferences) {
    return (
      <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 p-4 shadow-lg z-50">
        <div className="container mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-start md:items-center gap-2">
            <span role="img" aria-label="cookie" className="mt-1 md:mt-0">🍪</span>
            <p className="text-sm text-slate-600 dark:text-slate-400">
              We use cookies to enhance your experience and analyse traffic. Some cookies are essential; others are optional.
            </p>
          </div>
          <div className="flex flex-col md:flex-row items-stretch md:items-center gap-2 w-full md:w-auto">
            <button
              onClick={acceptAll}
              className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors w-full md:w-auto"
            >
              Accept All
            </button>
            <button
              onClick={rejectNonEssential}
              className="bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 px-4 py-2 rounded-md text-sm font-medium transition-colors w-full md:w-auto"
            >
              Reject Optional
            </button>
            <button
              onClick={() => setShowPreferences(true)}
              className="inline-flex items-center justify-center gap-1 text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white text-sm font-medium transition-colors w-full md:w-auto px-4 py-2 border border-slate-200 dark:border-slate-700 rounded-md"
            >
              <Settings className="h-4 w-4" />
              Manage
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Dialog
      open={showPreferences}
      onClose={() => setShowPreferences(false)}
      className="relative z-50"
    >
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto w-full max-w-xl rounded-xl bg-white p-6 shadow-lg">
          <Dialog.Title className="text-xl font-semibold">
            Cookie Preferences
          </Dialog.Title>

          <div className="mt-4 space-y-4">
            <div className="space-y-4">
              <label className="flex items-start space-x-3">
                <input
                  type="checkbox"
                  checked={preferences.essential}
                  disabled
                  className="h-4 w-4 mt-1 rounded border-gray-300"
                />
                <div>
                  <span className="font-medium">Essential Cookies</span>
                  <p className="text-sm text-gray-500">Required for the website to function properly.</p>
                </div>
              </label>

              <label className="flex items-start space-x-3">
                <input
                  type="checkbox"
                  checked={preferences.analytics}
                  onChange={(e) =>
                    savePreferences({ analytics: e.target.checked })
                  }
                  className="h-4 w-4 mt-1 rounded border-gray-300"
                />
                <div>
                  <span className="font-medium">Analytics Cookies</span>
                  <p className="text-sm text-gray-500">Help us understand how visitors interact with our website.</p>
                </div>
              </label>

              <label className="flex items-start space-x-3">
                <input
                  type="checkbox"
                  checked={preferences.marketing}
                  onChange={(e) =>
                    savePreferences({ marketing: e.target.checked })
                  }
                  className="h-4 w-4 mt-1 rounded border-gray-300"
                />
                <div>
                  <span className="font-medium">Marketing Cookies</span>
                  <p className="text-sm text-gray-500">Used to deliver personalized advertisements.</p>
                </div>
              </label>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row justify-end gap-3">
              <button
                onClick={() => setShowPreferences(false)}
                className="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                Close
              </button>
              <button
                onClick={() => {
                  savePreferences(preferences);
                  setShowPreferences(false);
                }}
                className="w-full sm:w-auto px-4 py-2 bg-indigo-600 text-white rounded-md text-sm font-medium hover:bg-indigo-700"
              >
                Save Preferences
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};
